import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ContextService } from 'src/app/services/context.service';
import { DropboxService } from 'src/app/services/dropbox.service';
import { ProcoreService } from 'src/app/services/procore.service';

@Component({
	selector: 'app-file',
	templateUrl: './file.component.html',
	styleUrls: ['./file.component.css']
})
export class FileComponent implements OnInit {
	@Output() emitUploadedDoc = new EventEmitter<any>();
	@Output() emitLoadingGeneratedFile = new EventEmitter<any>();
	@Output() emitTemplates = new EventEmitter<any>();
	@Output() emitSelectedTemplate = new EventEmitter<any>();
	@Output() emitUseGeneratedFile = new EventEmitter<any>();

	loadingGeneratedFile = false;

	showFileMenu = false;
	showDragDropBorder: boolean = false;

	fileType = 'generate';  // generate, upload, template
	generatedFileExists = false;

	uploadedDoc: any;

	templates = [];
	selectedTemplate;

	generatedFileUrl = '';

	constructor(
		public contextService: ContextService,
		private dropboxService: DropboxService,
		private procoreService: ProcoreService
	) { }

	ngOnInit() {
		this.startPDFGeneration();
	}

	startPDFGeneration() {
		this.generatedFileUrl = '';

		console.log(this.contextService.procoreContextObject.context);
		const exportedFileViews = ['prime_contracts.detail', 'prime_contracts.change_orders.detail', 'prime_contracts.prime_contracts_change_orders_batches.detail', 'prime_contracts.prime_contracts_change_orders.detail', 'commitments.purchase_order_contracts.detail', 'commitments.work_order_contracts.detail', 'commitments.potential_change_orders.detail', 'commitments.commitment_contract_change_orders.detail', 'commitments.commitment_contract_change_orders_batches.detail', 'commitments.requisitions.detail', 'invoicing.requisitions.detail', 'prime_contracts.payment_applications', 'invoicing.payment_applications.detail'];
		//if (this.contextService.clientDetailProcore.useExportedFile && exportedFileViews.indexOf(this.contextService.procoreContextObject.context.view) > -1) {
		if (exportedFileViews.indexOf(this.contextService.procoreContextObject.context.view) > -1) {
			this.loadingGeneratedFile = true;
			this.emitLoadingGeneratedFile.emit(true);
			const fileContext = {
				companyId: this.contextService.procoreContextObject.context.company_id,
				projectId: this.contextService.procoreContextObject.context.project_id,
				itemId: this.contextService.procoreContextObject.context.id,
				route: this.contextService.procoreContextObject.context.route
			}

			this.procoreService.startGenerateFile(fileContext, this.contextService.procoreContextObject.context.view, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
				.subscribe({
					next: (startResponse) => {
						//let _this = this;
						let index = 0;

						if (startResponse) {
							this.generatedFileUrl = startResponse;

							this.contextService.procoreContextObject.context.generatedFileUrl = startResponse;

							if (this.contextService.procoreContextObject.context.view == 'commitments.requisitions.detail' || this.contextService.procoreContextObject.context.view == 'invoicing.requisitions.detail' || this.contextService.procoreContextObject.context.view == 'prime_contracts.payment_applications' || this.contextService.procoreContextObject.context.view == 'invoicing.payment_applications.detail') {
								this.contextService.procoreContextObject.context.generatedFileType = "coversheet";
							} else {
								this.contextService.procoreContextObject.context.generatedFileType = "pdf";
							}

							this.generatedFileExists = true;

							this.loadingGeneratedFile = false;
							this.emitLoadingGeneratedFile.emit(false);
							this.emitUseGeneratedFile.emit(true);
						} else {
							this.fileType = 'upload';
							this.generatedFileExists = false;
							this.loadingGeneratedFile = false;
							this.emitLoadingGeneratedFile.emit(false);
							this.emitUseGeneratedFile.emit(false);
						}

						// NOTE: CALL THIS AFTER START GENERATE FILE TO AVOID A EXPIRED ACCESS TOKEN ISSUE
						if (this.contextService.clientDetailProcore.enableDropboxSignTemplates || this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays) {
							this.retrieveTemplates();
						} else {
							this.templates = [];
							this.emitTemplates.emit(this.templates);
						}
					},
					error: () => {
						this.fileType = 'upload';
						this.generatedFileExists = false;
						this.loadingGeneratedFile = false;
						this.emitLoadingGeneratedFile.emit(false);
						this.emitUseGeneratedFile.emit(false);

						if (this.contextService.clientDetailProcore.enableDropboxSignTemplates || this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays) {
							this.retrieveTemplates();
						} else {
							this.templates = [];
							this.emitTemplates.emit(this.templates);
						}
					}
				});

		} else {
			this.fileType = 'upload';
			this.generatedFileExists = false;
			this.loadingGeneratedFile = false;
			this.emitLoadingGeneratedFile.emit(false);
			this.emitUseGeneratedFile.emit(false);

			if (this.contextService.clientDetailProcore.enableDropboxSignTemplates || this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays) {
				this.retrieveTemplates();
			} else {
				this.templates = [];
				this.emitTemplates.emit(this.templates);
			}
		}
	}

	retrieveTemplates() {
		this.dropboxService.getTemplates(this.contextService.procoreContextObject.context.company_id, this.contextService.signatureCount?.dropboxSignUsername).subscribe((result) => {
			this.templates = result;
			this.templates.sort((a, b) => a.title.localeCompare(b.title));

			this.emitTemplates.emit(this.templates);
		});
	}

	setSelectedTemplate(template) {
		this.selectedTemplate = template;

		this.fileType = 'template';
		this.emitSelectedTemplate.emit(template);
		this.emitUseGeneratedFile.emit(false);

		this.showFileMenu = false;
	}

	fileUploaded(e: any) {
		if (e.target) {
			this.uploadedDoc = e.target.files[0];
		} else {
			this.uploadedDoc = e[0];
		}
		this.emitUploadedDoc.emit(this.uploadedDoc);

		this.showDragDropBorder = false;

		this.fileType = 'upload';
		this.emitSelectedTemplate.emit('');
		this.emitUseGeneratedFile.emit(false);

		this.showFileMenu = false;
	}

	viewFile() {
		window.open(this.generatedFileUrl);
	}

	selectFileType(type) {
		this.fileType = type;
		this.emitSelectedTemplate.emit('');

		if (type == 'generate') {
			this.emitUseGeneratedFile.emit(true);
		} else {
			this.emitUseGeneratedFile.emit(false);
		}

		this.showFileMenu = false;
	}
}
